import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TextItalicFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TextItalicFilled({
  title = 'Text italic',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Text italic'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="M19 5V2h-9v3h2.6L7.2 19H4v3h9v-3h-2.6l5.4-14H19Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default TextItalicFilled;